<template>
  <div :id="htmlid"></div>
</template>

<script>
import Vex from "vexflow";
import { randInt } from "@/helpers/randInt";

export default {
  name: "Score",
  props: {
    notes: { type: [Array, String], required: true },
    width: { type: String, default: "560" },
    height: { type: Number, default: 150 }
  },
  data() {
    return {
      htmlid: `score-${randInt()}`
    };
  },
  mounted() {
    const vf = new Vex.Flow.Factory({
      renderer: {
        elementId: this.htmlid,
        width: this.width,
        height: this.height
      }
    });
    const notes =
      typeof this.notes === "string" ? [{ notes: this.notes }] : this.notes;

    const score = vf.EasyScore();
    const system = vf.System();
    const voices = notes.map(voice =>
      score.voice(score.notes(voice.notes, { stem: voice.stem || "up" }))
    );
    system
      .addStave({
        voices
      })
      .addClef("treble")
      .addTimeSignature("4/4");

    vf.draw();
  }
};
</script>

<style scoped>
#score {
  overflow-x: auto;
  transform: scale(0.9);
}
</style>
